import "./customerProfile.scss";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import CustomerPrice from "./CustomerPrice";
import Loading from "../loading/Loading";

const CustomerProfile = ({ cusId, resetOrder }) => {
  const [profile, setProfile] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiRes, setApiRes] = useState("false");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOderId, setSelectedOderId] = useState(null);
  const [orderData, setOrderData] = useState({});
  const [select, setSelect] = useState("price");

  useEffect(() => {
    if (resetOrder) {
      setSelectedOderId(null);
    }
  }, [resetOrder]);

  const buyerId = cusId;
  const [orders, setOrders] = useState([]);

  const columns = [
    { field: "orderId", headerName: "Order ID.", width: 200 },
    { field: "customer", headerName: "Customer", width: 220 },
    {
      field: "orderStatus",
      headerName: "Order Status",
      width: 150,
      renderCell: (params) => (
        <span
          style={{
            color: params.value?.toLowerCase() === "shipped" ? "green" : "red",
            fontWeight: 600,
          }}
        >
          {params.value}
        </span>
      ),
    },
    {
      field: "paymentStatus",
      headerName: "Payment Status",
      width: 150,
      renderCell: (params) => (
        <span
          style={{
            color:
              params.value?.toLowerCase() === "complete" ? "green" : "orange",
            fontWeight: 600,
          }}
        >
          {params.value}
        </span>
      ),
    },
    { field: "address", headerName: "Address", width: 200 },
    { field: "paymentMethod", headerName: "Payment Method", width: 150 },
    { field: "deliveryCost", headerName: "Delivery Cost", width: 120 },
    { field: "totalAmount", headerName: "Total Amount", width: 120 },
  ];

  useEffect(() => {
    const getAllOrders = async () => {
      try {
        const response = await axios.get(`/get-buyer-orders/${buyerId}`);
        const mappedOrders = response.data.map((order) => ({
          id: order._id, // for DataGrid's internal use
          orderId: order.orderId || "",
          customer: order.fullName || "",
          brand: order.brand || "",
          city: order.city || "",
          address: order.address || "",
          homeName: order.homeName || "",
          landmark: order.landmark || "",
          orderStatus: order.orderStatus || "",
          paymentMethod: order.paymentMethod || "",
          paymentStatus: order.paymentStatus || "",
          totalAmount: order.totalAmount || 0,
          deliveryCost: order.deliveryCost || 0,
          productsList: order.products || [],
        }));

        setOrders(mappedOrders);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };
    getAllOrders();
  }, [cusId, select]);

  useEffect(() => {
    if (!cusId) {
      return;
    }
    const getProfile = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`/get-customer-profile/${cusId}`);
        setProfile(response.data);
      } catch (error) {
        return;
      } finally {
        setLoading(false);
      }
    };
    getProfile();
  }, [cusId, apiRes, select]);

  const handleStatus = async (status) => {
    if (!status || !cusId) {
      return;
    }
    try {
      const response = await axios.put(
        `/update-customer-status/${cusId}?status=${status}`
      );
      setApiRes(response.data);
    } catch (error) {
      return;
    }
  };

  const backOder = () => {
    setSelectedOderId("");
  };

  useEffect(() => {
    if (!selectedOderId) {
      return;
    }
    const getOderDetails = async () => {
      try {
        const response = await axios.get(`/get-order-data/${selectedOderId}`);
        setOrderData(response.data);
      } catch (error) {
        return;
      }
    };
    getOderDetails();
  }, [selectedOderId, apiRes, select]);

  const handleOrderStatus = async (status) => {
    if (!status) {
      return;
    }
    try {
      const response = await axios.put(
        `/update-order-status/${selectedOderId}?status=${status}`
      );
      setApiRes(response.data);
    } catch (error) {
      return;
    }
  };

  const handlePaymentStatus = async (status) => {
    if (!status) {
      return;
    }
    try {
      const response = await axios.put(
        `/update-order-payment-status/${selectedOderId}?status=${status}`
      );
      setApiRes(response.data);
    } catch (error) {
      return;
    }
  };


  return (
    <>
      {loading ? (
        <div className="cus_wrp">
          <Loading />
        </div>
      ) : (
        <div className="cus_wrp">
          <div className="profile_wrp">
            <div className="p_sec_cu">
              <small>{profile.buyerId}</small>
              <h5>{profile?.fullName}</h5>
              <p>{profile.email}</p>
              <br />
              <div className="ad_wrp">
                <strong>Address</strong>
                <p>
                  {profile.address}, {profile.homeName}, {profile.landmark},{" "}
                  {profile.city}
                </p>
              </div>
            </div>
            {!selectedOderId ? (
              <div className="p_sec">
                <div className="d_in">
                  <strong>Customr Status :</strong>
                  <span
                    className={`status ${profile.isVerified?.toLowerCase()}`}
                  >
                    {profile.isVerified}
                  </span>
                </div>
                <div className="d_in">
                  <div className="v_btn" onClick={() => handleStatus("verify")}>
                    <span>Verify</span>
                  </div>
                  <div
                    className="v_btn"
                    onClick={() => handleStatus("unverify")}
                  >
                    <span>Unverify</span>
                  </div>
                  <div className="v_btn" onClick={() => handleStatus("block")}>
                    <span>Block</span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="p_sec">
                <div>
                  <div className="d_in">
                    <strong>Order Status :</strong>
                    <span
                      className={`status ${orderData.orderStatus?.toLowerCase()}`}
                    >
                      {orderData.orderStatus}
                    </span>
                  </div>
                  <div className="d_in">
                    <div
                      className="v_btn"
                      onClick={() => handleOrderStatus("shipped")}
                    >
                      <span>Shipped</span>
                    </div>
                    <div
                      className="v_btn"
                      onClick={() => handleOrderStatus("processing")}
                    >
                      <span>Processing</span>
                    </div>
                    <div
                      className="v_btn"
                      onClick={() => handleOrderStatus("onHold")}
                    >
                      <span>On Hold</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="d_in">
                    <strong>Payment Status :</strong>
                    <span
                      className={`status ${orderData.paymentStatus?.toLowerCase()}`}
                    >
                      {orderData.paymentStatus}
                    </span>
                  </div>
                  <div className="d_in">
                    <div
                      className="v_btn"
                      onClick={() => handlePaymentStatus("complete")}
                    >
                      <span>Complete</span>
                    </div>
                    <div
                      className="v_btn"
                      onClick={() => handlePaymentStatus("pending")}
                    >
                      <span>Pending</span>
                    </div>
                    <div
                      className="v_btn"
                      onClick={() => handlePaymentStatus("onHold")}
                    >
                      <span>On Hold</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <br />

          <div className="cus_btn_wrp">
            <button onClick={() => setSelect("price")}>Customer price</button>
            <button onClick={() => setSelect("orders")}>All Orders</button>
          </div>
          <div className="hr"></div>
          <br />

          <div className="main_page_wrp">
            {select === "price" && (
              <>
                {!selectedOderId ? (
                  <div className="___heading">
                    <h5>
                      Customer <em>Price</em>
                    </h5>
                    <div className="main_body_wrp">
                      <div className="price_section">
                        <CustomerPrice buyerId={profile.buyerId} />
                      </div>
                    </div>
                  </div>
                ) : (
                  <p>No Price Found</p>
                )}
              </>
            )}

            {select === "orders" && (
              <>
                {!selectedOderId ? (
                  <div className="main_page_wrp">
                    <div className="___heading">
                      <h5>
                        All <em>Orders</em>
                      </h5>
                    </div>
                    <div className="main_body_wrp">
                      <DataGrid
                        rows={orders}
                        columns={columns}
                        pageSize={5}
                        disableRowSelectionOnClick
                        getRowId={(row) => row.id}
                        slots={{ toolbar: GridToolbar }}
                        onCellClick={(params) => {
                          setSelectedOderId(params.row.id);
                        }}
                        slotProps={{
                          toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                          },
                        }}
                        sx={{
                          "& .MuiDataGrid-row": {
                            cursor: "pointer",
                          },
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="oder_details">
                    <div className="back_btn_wrp" onClick={backOder}>
                      {selectedOderId && (
                        <div>
                          <strong>Order ID :</strong>{" "}
                          <span style={{ color: "#1976d2" }}>
                            {orderData.customer_reference_number}
                          </span>
                        </div>
                      )}
                      <div className="back_btn">
                        <span>Back</span>
                      </div>
                    </div>
                    <div className="products-list">
                      {Array.isArray(orderData.products) &&
                      orderData.products.length > 0 ? (
                        <ul>
                          <>
                            {orderData.products.map((item, i) => (
                              <li key={i} className="product-item">
                                <span className="p-name">{item.title}</span>
                                <span className="p-price">
                                  {item.price} AED
                                </span>
                                <span className="p-qty">
                                  {item.quantity} kg
                                </span>
                                <span className="p-weight">
                                  {item.quantity * item.price} AED
                                </span>
                              </li>
                            ))}

                            <div className="order-total">
                              <strong>Total Amount:</strong>{" "}
                              <strong>{orderData.totalAmount} AED</strong>
                            </div>
                          </>
                        </ul>
                      ) : (
                        <p>No Products Found</p>
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CustomerProfile;
